{
  "iron_plate": { "name": "Placas de hierro", "seconds": 3, "in": { "iron_ore": 1 }, "out": { "iron_plate": 1 } },
  "gear": { "name": "Engranajes", "seconds": 4, "in": { "iron_plate": 2 }, "out": { "gear": 1 } }
}
